import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { careerInterestProps } from "../types";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_CAREER_INTEREST = "career-interest";

const getData = async (props: {
  token: string;
  talent_id: string;
}): Promise<careerInterestProps[]> => {
  const url = `${END_POINT.BASE_URL}/v1/get-talent-career-interests/${props.talent_id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: careerInterestProps[] = res.data;
  return item;
};

export const useGetCareerInterest = () => {
  const { token, userInfo } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_CAREER_INTEREST],
    () => getData({
        token,
        talent_id: userInfo?.talent.id
    }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
